export enum CartOrderMergeStrategy {
  KeepDraftQuantities = 'keepDraftQuantities',
  ReplaceWithCartQuantities = 'replaceWithCartQuantities',
  MergeQuantities = 'mergeQuantities',
}
